import Button, { ButtonProps } from '@mui/material/Button';
import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Stack, Typography } from '@mui/material';
import { Trans } from '@lingui/macro';

export default function ExpandButton(p: ButtonProps) {
  return (
    <Button
      variant='outlined'
      fullWidth
      size='small'
      {...p}
      endIcon={
        <>
          {!p.disabled && (
            <Stack
              color='var(--color-primary)'
              fontSize='0.2rem'
              direction='row'
              alignItems='center'
            >
              <EditIcon fontSize='0.2rem' />
              <Typography>
                &nbsp;<Trans>Edit</Trans>
              </Typography>
            </Stack>
          )}
        </>
      }
    >
      <Box
        style={{
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
      >
        {p.children}
      </Box>
      {/* Push the end icon to far right */}
      <span style={{ flexGrow: 1 }} />
    </Button>
  );
}
